<div class="modal-body office-settings-danger-modal">
  <button class="close" (click)="modalRef.dismiss()">&times;</button>
  <form class="office-settings-modal-form">
    <h2 class="header modal-title">
      <span i18n="@@office-setting.remove-service">Remove Service</span>
    </h2>
    <div class="body">
      <p>
        <span i18n="@@global.sure-remove">Are you sure you want to remove the</span>
        {{ officeChargeToDelete.name }}
        <span i18n="@@global.from-list-services">from your list of services?</span>
      </p>
    </div>
    <div class="d-flex justify-content-center w-100" style="gap: 10px">
      <button
        class="btn btn-secondary"
        type="button"
        (click)="modalRef.dismiss()"
        i18n="@@global.cancel"
      >
        Cancel
      </button>
      <button
        class="btn btn-danger"
        type="button"
        (click)="deleteOfficeCharge()"
        i18n="@@office-remove-user-modal.remove"
      >
        Remove
      </button>
    </div>
  </form>
</div>
